import React from "react";
import "./styles.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wrap">Github: FacuEM</div>
    </footer>
  );
};

export default Footer;
